const SET_TLP_PAGE = 'SET_TLP_PAGE';

export { SET_TLP_PAGE };
